<template>
  <div id="app-shell">
    <!-- Navigation bar (only when authenticated) -->
    <AppHeader v-if="auth.isAuthenticated" />

    <!-- Router view -->
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>

    <!-- Global toast notifications -->
    <ToastContainer />
  </div>
</template>

<script setup>
import AppHeader from '@/components/AppHeader.vue'
import ToastContainer from '@/components/ToastContainer.vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
</script>

<style>
.main-content:has(>.login-page),
.main-content:has(>.home-page),
.main-content:has(>.not-found-page) {
  padding: 0px;
}

#app-shell:has(.not-found-page) .header {
  display: none;
}

.main-content {
  flex: 1;
  padding: 24px;
  max-width: 1600px;
  width: 100%;
  margin: 0 auto;
}

.fade-enter-active,
.fade-leave-active { transition: opacity .15s; }
.fade-enter-from,
.fade-leave-to { opacity: 0; }
</style>
